import PropTypes from "prop-types";
import React, { Component } from "react";
import { FaArrowRight, FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../../assets_/_login.css";
import PhoneNumber from "../../../components/Inputs/PhoneNumber";
import DateInput from "../../../components/Inputs/DateInput";
import Select from "react-select"; // Ensure you're using react-select
import RegisterForm from "./RegisterForm";

class Register extends Component {


  render() {
    const sexes = [
      { value: "homme", label: "Homme" },
      { value: "femme", label: "Femme" },
    ];

    return (
      <div className="login-form">
        <main className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            <div className="card login-card">
              <div className="row no-gutters">
                <div className="col-md-5  d-xs-none d-md-flex d-lg-flex d-sm-none">
                  <img
                    src="https://demo.bootstrapdash.com/login-template-free-2/assets/images/login.jpg"
                    alt="login"
                    className="login-card-img"
                  />
                </div>
                <div className="col-md-7">
                  <div className="card-body">
                    <Link to="/" className="brand-wrapper">
                      <img
                        src="assets/img/hna-meak/Hna_m3ak_logo2.png"
                        alt="logo"
                        className="logo"
                      />
                    </Link>
                    <p className="login-card-description">S'inscrire</p>
                    
                    <RegisterForm></RegisterForm>

                    <a href="!#" className="forgot-password-link">
                      Mot de passe oublié?
                    </a>
                    <p className="login-card-footer-text">
                      Vous avez déjà un compte ?
                      <Link to="/login" className="ms-1 text-decoration-underline">
                        Se connecter
                      </Link>
                    </p>
                    <nav className="login-card-footer-nav">
                      <a href="#!">Terms of use.</a>
                      <a href="#!">Privacy policy</a>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default Register;
